var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-exam"},[_c('Header',{attrs:{"fullHeader":false,"containerFluid":true}}),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('main',{staticClass:"col-md-12 py-3 px-4"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }